import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  href: {
    default: 'https://www.theaccessgroup.com/',
    editor: 'textbox',
  },
  target: {
    default: '_blank',
    editor: 'textbox',
  },
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  size: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'default', 'small', 'large'],
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  linkStyle: {
    editor: 'textbox',
    default: '',
  },
  linkContentStyle: {
    editor: 'textbox',
    default: '',
  },
};

const PlaygroundStoryKnobsReact: Knobs = {
  ...PlaygroundStoryKnobs,
  linkStyle: {
    ...PlaygroundStoryKnobs.buttonStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
  linkContentStyle: {
    ...PlaygroundStoryKnobs.buttonContentStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
};

const playgroundStory: Story = {
  title: 'Playground',
  description: 'A simple link button',
  coreComponent_v3: {
    html: `<tag3-link-button{{...knobs}}>
    Click me!
</tag3-link-button>`,
    knobs: PlaygroundStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3LinkButton{{...knobs}}>
    Click me!
</Tag3LinkButton>`,
    knobs: PlaygroundStoryKnobsReact,
  },
};

const IconStory: Story = {
  title: 'Icon',
  description: 'A link button with an icon',
  coreComponent_v3: {
    html: `<tag3-link-button href="https://analytics.google.com/" target="_blank">
    <tag3-icon-svg icon="BarChart"></tag3-icon-svg><span style="margin-left:3px;">Go to Analytics</span> 
</tag3-link-button>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3LinkButton href="https://analytics.google.com/" target="_blank">
    <Tag3IconSvg icon="BarChart"></Tag3IconSvg><span style={{marginLeft:"3px"}}>Go to Analytics</span> 
</Tag3LinkButton>`,
  },
};

export const TagLinkButtonDocs: Component = {
  type: 'component',
  name: 'link-button',
  description: 'Renders a link styled as a button',
  mobileFriendly: false,
  preRelease: 'alpha',
  popular: false,
  props: [
    {
      name: 'href',
      description: 'The href',
      type: 'string',
    },
    {
      name: 'target',
      description: 'The target',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The colour of the button',
      type: 'string',
      default: 'btndefault',
    },
    {
      name: 'size',
      description: 'The vertical size',
      type: 'default | large | small',
      default: 'default',
    },
    {
      name: 'disabled',
      description: 'Whether the link is disabled',
      type: 'boolean',
    },
    {
      name: 'linkStyle',
      description: 'JSX style object in JSON to apply to the button',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  methods: [],
  events: [],
  stories: [playgroundStory, IconStory],
};
